import { Mail, ArrowRight } from "lucide-react";
import { BUSINESS, IMAGES } from "../../lib/site-content";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full overflow-hidden" style={{ backgroundColor: '#f0ece4' }}>

      <div className="relative z-10 max-w-5xl mx-auto px-5 sm:px-8 pt-24 md:pt-28 pb-10 md:pb-14 text-center">
        <p className="text-sm sm:text-base font-semibold tracking-[0.22em] uppercase text-stone-900 mb-5">
          {BUSINESS.serviceArea}
        </p>

        <img
          src={BUSINESS.logo}
          alt="The Stone Remedy"
          className="mx-auto h-36 sm:h-44 md:h-52 w-auto object-contain mb-5"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />

        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05] text-stone-900 max-w-3xl mx-auto">
          Natural stone, <em className="italic font-normal text-stone-700">remembered.</em>
        </h1>

        <p className="mt-6 text-base sm:text-lg leading-relaxed text-stone-600 max-w-xl mx-auto">
          Master craftsmen restoring marble, granite, limestone and onyx for the most discerning
          residences and commercial properties across the tri-state.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 max-w-md sm:max-w-none mx-auto">
          <a
            href={BUSINESS.emailHref}
            className="inline-flex items-center justify-center gap-2 px-7 py-4 text-sm tracking-wider text-stone-900 border border-stone-900 hover:bg-stone-100 transition-colors"
          >
            <Mail className="w-4 h-4" />
            <span>Email Us</span>
          </a>
          <button
            onClick={() => scrollTo("schedule")}
            className="inline-flex items-center justify-center gap-2 px-7 py-4 text-sm tracking-wider text-stone-900 hover:text-stone-600 transition-colors"
          >
            <span>Schedule a Visit</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>


      </div>
    </section>
  );
}
